import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="nf-page">

    <div className="nf-content">

      {/* Stamp */}
      <div className="nf-stamp">
        <span className="nf-stamp-num">404</span>
        <span className="nf-stamp-jp">迷子</span>
      </div>

      <h1 className="nf-title">Đi đâu thế bro ?</h1>
      <p className="nf-desc">
        Trang này không tồn tại hoặc đã được chuyển đi nơi khác rồi nhớ.<br />
        Quay về lễ hội thôi! &#x1F338;
      </p>

      <div className="nf-actions">
        <Link to="/" className="nf-btn-home">&#x26E9; Về Trang Chủ</Link>
        <button className="nf-btn-back" onClick={() => window.history.back()}>&#x2190; Quay Lại</button>
      </div>

      <p className="nf-haiku">
        <span>道に迷いし</span>
        <span>桜の花びら舞う</span>
        <span>家路を探す</span>
      </p>
    </div>
  </div>
);

export default NotFound;
